export const MIN_LOGIN_LENGHT: number = 6;
export const MIN_PASSWORD_LENGHT: number = 6;